import { mapPersonalInfoType, PersonalInfoType } from "../PersonalInfoType";
import { mapUserRoleInfoType, UserRoleInfoType } from "../UserRoleInfoType";

/* ******************************************************* Attendance staff view */
export interface AttendanceStaffView {
    date?: string;
    personal_info_id?: number;
    project_data?: ProjectData | null;
    total_hours?: number;
    total_days?: number;
    total_wage?: number;
    other_expense_amount?: number;
    total_paid?: number;
    personalInfo?: PersonalInfoType | null;
    userRoleInfo?: UserRoleInfoType | null;
}

export const mapAttendanceStaffView = (staffData: any): AttendanceStaffView => {
    if (!staffData) {
        throw new Error('Invalid Data')
    }

    const response: AttendanceStaffView = {
        date: staffData.date,
        personal_info_id: staffData.personal_info_id,
        project_data: staffData.project_data !== null ? mapProjectData(staffData.project_data) : null,
        total_hours: staffData.total_hours,
        total_days: staffData.total_days,
        total_wage: staffData.total_wage,
        other_expense_amount: staffData.other_expense_amount,
        total_paid: staffData.total_paid,
        personalInfo: staffData.personalInfo !== null ? mapPersonalInfoType(staffData.personalInfo) : null,
        userRoleInfo: staffData.userRoleInfo !== null ? mapUserRoleInfoType(staffData.userRoleInfo) : null
    }

    return response;
}

export const mapAttendanceStaffViews = (data: any[]): AttendanceStaffView[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapAttendanceStaffView);
}
/* ******************************************************* */


/* ******************************************************* Attendance staff paid data */
export interface StaffPaidData {
    id: number;
    personal_info_id: number;
    date: string;
    payed_amount: number;
    expense_id: number;
}

export const mapStaffPaidData = (data: any): StaffPaidData => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: StaffPaidData = {
        id: data.id,
        personal_info_id: data.personal_info_id,
        date: data.date,
        payed_amount: data.payed_amount,
        expense_id: data.expense_id
    }

    return response;
}

export const mapStaffPaidDatas = (data: any[]): StaffPaidData[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapStaffPaidData);
}
/* ******************************************************* */


/* ******************************************************* Attendance other expense data */
export interface OtherExpenseData {
    id: number;
    expense_name?: string;
    total_amount?: number;
    list?: StaffPaidData[];
}

export const mapOtherExpenseData = (data: any): OtherExpenseData => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: OtherExpenseData = {
        id: data.id,
        expense_name: data.expense_name,
        total_amount: data.total_amount,
        list: Array.isArray(data.list) ? mapStaffPaidDatas(data.list) : []
    }

    return response;
}

export const mapOtherExpenseDatas = (data: any[]): OtherExpenseData[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapOtherExpenseData);
}
/* ******************************************************* */


/* ******************************************************* Attendance date color */
export interface DateColor {
    date?: string;
    colour_code?: string;
}

export const mapDateColor = (data: any): DateColor => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: DateColor = {
        date: data.date,
        colour_code: data.colour_code
    }

    return response;
}

export const mapDateColors = (data: any[]): DateColor[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapDateColor);
}
/* ******************************************************* */


/* ******************************************************* Attendance project wise data */
export interface ProjectWiseData {
    project_id?: number;
    colour_code?: string;
    project_data?: ProjectData | null;
    count?: number;
    dates?: string[];
}

export const mapProjectWiseData = (data: any): ProjectWiseData => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: ProjectWiseData = {
        project_id: data.project_id,
        colour_code: data.colour_code,
        project_data: data.project_data !== null ? mapProjectData(data.project_data) : null,
        count: data.count,
        dates: Array.isArray(data.dates) ? data.dates : [],
    }

    return response;
}

export const mapProjectWiseDatas = (data: any[]): ProjectWiseData[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapProjectWiseData);
}
/* ******************************************************* */


/* ******************************************************* Attendance project wise data */
export interface ProjectData {
    project_id?: number;
    job_number?: string;
    project_type?: string;
    description?: string | null;
    status?: string;
    user_id?: number;
    address?: string | null;
    post_code?: string | null;
    full_address?: string | null;
}

export const mapProjectData = (data: any): ProjectData => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: ProjectData = {
        project_id: data.project_id,
        job_number: data.job_number,
        project_type: data.project_type,
        description: data.description ?? null,
        status: data.status,
        user_id: data.user_id,
        address: data.address ?? null,
        post_code: data.post_code ?? null,
        full_address: data.full_address ?? null,
    }

    return response;
}

export const mapProjectDatas = (data: any[]): ProjectData[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapProjectData);
}
/* ******************************************************* */